import { render, staticRenderFns } from "./clubInfoSetting.vue?vue&type=template&id=58ffe50e"
import script from "./clubInfoSetting.vue?vue&type=script&lang=js"
export * from "./clubInfoSetting.vue?vue&type=script&lang=js"
import style0 from "./clubInfoSetting.vue?vue&type=style&index=0&id=58ffe50e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports